module.exports = __webpack_public_path__ + "c701964693a7e16ae90b1a506dc9ee19.png";